import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TopBar } from './TopBar';
import { TabBar } from './TabBar';
import { TopNav } from './TopNav';
import { AppShellChromeProvider, useAppShellChrome } from '../hooks/useAppShellChrome';
import { useViewport } from '../hooks/useViewport';
/**
 * M2 alpha utility-first cyanotype — DEC-014, étendu Wave M5-webapp.
 *
 * Shell minimal :
 *   - mobile / tablet (<1024px) : TopBar mobile + content max-w 430→768 + TabBar bottom
 *   - desktop (>=1024px)        : TopNav horizontal + content max-w 1280 + pas de TabBar
 *
 * BackdropLayer/ParticleLayer narratifs supprimes (Wave Reset jete). Le bg
 * cyanotype + blueprint grid optionnel sont herites du body globals.css.
 */
function ShellChrome({ children }) {
    const { visible } = useAppShellChrome();
    const { isDesktop } = useViewport();
    if (isDesktop) {
        return (_jsxs("div", { className: "relative isolate min-h-dvh bg-cyan-bg", children: [visible ? _jsx(TopNav, {}) : null, _jsx("main", { className: "relative z-[1] mx-auto flex min-h-dvh w-full max-w-[1280px] flex-col px-8 pt-8 pb-12", children: _jsx("div", { className: "flex-1", children: children }) })] }));
    }
    return (_jsxs("div", { className: "relative isolate min-h-dvh bg-cyan-bg", children: [visible ? _jsx(TopBar, {}) : null, _jsx("main", { className: "relative z-[1] mx-auto flex min-h-dvh w-full max-w-[430px] md:max-w-[720px] flex-col px-5 md:px-8 pt-4", style: {
                    paddingBottom: visible
                        ? 'calc(56px + env(safe-area-inset-bottom) + 16px)'
                        : '0',
                }, children: _jsx("div", { className: "flex-1", children: children }) }), visible ? _jsx(TabBar, {}) : null] }));
}
export function AppShell({ children }) {
    return (_jsx(AppShellChromeProvider, { children: _jsx(ShellChrome, { children: children }) }));
}
/**
 * Compat hook : ancien `useShellBackdrop` utilise par les pages narratives
 * (Home, lore, etc.). En M2 utility-first, le shell n'a plus de backdrop —
 * le hook renvoie un no-op pour ne pas casser les imports residuels avant
 * leur suppression A11.
 */
export function useShellBackdrop() {
    return {
        backdrop: null,
        setBackdrop: () => undefined,
    };
}
//# sourceMappingURL=AppShell.js.map